export enum JobStage {
  Held = 1,
  Capacity = 2,
  BuyNow = 3,
  GrabDisabled = 4,
}
